export const getIsCRMEmbedded = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return false;
  }
};